import { render, staticRenderFns } from "./tasktable-component.vue?vue&type=template&id=358fb7dc"
import script from "./tasktable-component.vue?vue&type=script&lang=ts"
export * from "./tasktable-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports